import React from 'react';
import PropTypes from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import I18n from 'i18n-react';
import EventEmitter from '../../../modules/event-emitter/EventEmitter';
import Listener from '../../../../const/Listener';
import LoggedUser from '../../../loggedUser/LoggedUser';
import Logout from '../../../logout/Logout';
import './Header.css';

const LOGIN_DATA_KEY = 'loginData';

const propTypes = {
  cookies: PropTypes.instanceOf(Cookies).isRequired
};

class Header extends React.Component {
  constructor() {
    super();
    this.state = {
      isLogged: false
    };
  }

  componentDidMount() {
    this.setState({
      updateHeader: EventEmitter.createListener(Listener.UPDATE_HEADER, this.updateStateFromCookie)
    });
    this.updateStateFromCookie();
  }

  componentWillUnmount() {
    EventEmitter.removeListener(this.state.updateHeader);
  }

  updateStateFromCookie = () => {
    const { cookies } = this.props;

    let data = cookies.get(LOGIN_DATA_KEY);
    if (data) {
      this.setState({
        isLogged: true,
        name: data.firstName,
        tudoAzulNumber: data.username,
        points: data.pointsBalance
      });
    } else {
      this.setState({ isLogged: false });
    }
  };

  renderDesktop() {
    return (
      <div className="ta-header-wrapper">
        <div className="container">
          <div className="ta-header-logo">
            <a href="/" target="_self">
              <img src="styles/img/azul-logo-color@2x.png" width="120" alt="" />
            </a>
          </div>
          <div className="ta-menu-header" aria-expanded="false" style={{ height: 1 }}>
            <li className="ta-item-menu">
              <a
                className="ta-item-link"
                href="https://www.voeazul.com.br/br/pt/sua-viagem"
                target="_blank"
                rel="noopener noreferrer">
                {I18n.translate('components.header.forYourtrip')}
              </a>
              <div className="submenu">
                <section className="section">
                  <div className="submenu-outter">
                    <div className="grid-g">
                      <div className="left submenu-border">
                        <div className="submenu-links">
                          <a
                            href="https://www.voeazul.com.br/br/pt/sua-viagem"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="submenu-link skin-0064 text--0002">
                            <span className="icon important-info-2" aria-hidden="true" />{' '}
                            {I18n.translate('components.header.travelInformation')}
                          </a>
                        </div>
                      </div>
                      <div className="right spacer--t10 text-left">
                        <nav>
                          <h2 className="screen-reader-only">
                            {I18n.translate('components.header.forYourTrip')}
                          </h2>
                          <ul>
                            <li className="pull-left">
                              <a
                                href="https://www.voeazul.com.br/br/pt/sobreazul/aplicativo-azul"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.azulApplication')}
                              </a>
                            </li>
                            <li className="pull-left">
                              <a
                                href="https://www.voeazul.com.br/br/pt/home/azulwebcheckin"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.formsCheckin')}
                              </a>
                            </li>
                            <li className="pull-left">
                              <a
                                href="https://www.voeazul.com.br/br/pt/sua-viagem/assentos"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.seats')}
                              </a>
                            </li>
                            <li className="pull-left">
                              <a
                                href="https://www.voeazul.com.br/br/pt/sua-viagem/planeje/bagagens"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.baggageChecked')}
                              </a>
                            </li>
                            <li className="pull-left">
                              <a
                                href="https://www.voeazul.com.br/br/pt/ofertas"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.promotions')}
                              </a>
                            </li>
                            <li className="pull-left">
                              <a
                                href="https://www.voeazul.com.br/br/pt/disney"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.disneyWorld')}
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </li>
            <li className="ta-item-menu">
              <a
                className="ta-item-link"
                href="https://www.voeazul.com.br/br/pt/sua-viagem/experiencia-azul"
                target="_blank"
                rel="noopener noreferrer">
                {I18n.translate('components.header.azulExperience')}
              </a>
              <div className="submenu">
                <section className="section">
                  <div className="submenu-outter">
                    <div className="grid-g">
                      <div className="left submenu-border">
                        <div className="submenu-links">
                          <a
                            href="https://www.voeazul.com.br/br/pt/sua-viagem/experiencia-azul"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="submenu-link skin-0064 text--0002">
                            <span className="icon international-product" aria-hidden="true" />{' '}
                            {I18n.translate('components.header.azulExperience')}
                          </a>
                        </div>
                      </div>
                      <div className="right spacer--t10 text-left">
                        <nav>
                          <h2 className="screen-reader-only">
                            {I18n.translate('components.header.azulExperience')}
                          </h2>
                          <ul>
                            <li className="pull-left">
                              <a
                                href="https://www.voeazul.com.br/br/pt/sobreazul/experiencia-azul/onibus-azul"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.azulBus')}
                              </a>
                            </li>
                            <li className="pull-left">
                              <a
                                href="https://www.voeazul.com.br/br/pt/sobreazul/experiencia-azul/azul-estacionamento"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.azulParking')}
                              </a>
                            </li>
                            <li className="pull-left">
                              <a
                                href="https://www.voeazul.com.br/br/pt/sobreazul/experiencia-azul/revista-azul"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.magazineAzul')}
                              </a>
                            </li>
                            <li className="pull-left">
                              <a
                                href="https://www.voeazul.com.br/br/pt/sua-viagem/assentos"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.seats')}
                              </a>
                            </li>
                            <li className="pull-left">
                              <a
                                href="https://www.voeazul.com.br/br/pt/sua-viagem/experiencia-azul/lounges"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.lounges')}
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </li>
            <li className="ta-item-menu">
              <a
                className="ta-item-link"
                href="https://www.voeazul.com.br/br/pt/imprensa/sobre-a-azul"
                target="_blank"
                rel="noopener noreferrer">
                {I18n.translate('components.header.meetAzul')}
              </a>
              <div className="submenu">
                <section className="section">
                  <div className="submenu-outter">
                    <div className="grid-g">
                      <div className="left submenu-border">
                        <div className="submenu-links">
                          <a
                            href="https://www.voeazul.com.br/br/pt/imprensa/sobre-a-azul"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="submenu-link skin-0064 text--0002">
                            <span className="icon about-azul-3" aria-hidden="true" />{' '}
                            {I18n.translate('components.header.aboutBlue')}
                          </a>
                          <a
                            href="https://www.voeazul.com.br/br/pt/sobreazul/mapa-de-rotas"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="submenu-link skin-0064 text--0002">
                            <span className="icon map" aria-hidden="true" />{' '}
                            {I18n.translate('components.header.maps')}
                          </a>
                        </div>
                      </div>
                      <div className="right spacer--t10 text-left">
                        <nav>
                          <h2 className="screen-reader-only">
                            {I18n.translate('components.header.meetAzul')}
                          </h2>
                          <ul>
                            <li className="pull-left">
                              <a
                                href="https://www.azulviagens.com.br"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.azulTravel')}
                              </a>
                            </li>
                            <li className="pull-left">
                              <a
                                href="https://www.voeazul.com.br/br/pt/imprensa/sala-de-imprensa"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.press')}
                              </a>
                            </li>
                            <li className="pull-left">
                              <a
                                href="https://www.voeazul.com.br/br/pt/sobreazul/conheca-azul/trabalhe-na-azul"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.workAzul')}
                              </a>
                            </li>
                            <li className="pull-left">
                              <a
                                href="https://www.voeazul.com.br/br/pt/sobreazul/politica-de-privacidade"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.privacyPolicy')}
                              </a>
                            </li>
                            <li className="pull-left">
                              <a
                                href="https://ri.voeazul.com.br/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="submenu-link-item skin-0064 text--0002">
                                {I18n.translate('components.header.relationship')}
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </li>
          </div>
          <nav className="ta-menu-header -secondary">
            <li className="ta-item-menu">
              <a
                className="ta-item-link"
                href="http://www.azulviagens.com.br/"
                target="_blank"
                rel="noopener noreferrer">
                {I18n.translate('components.header.azulTravel')}
              </a>
            </li>
            <li className="ta-item-menu">
              <a
                className="ta-item-link"
                href="http://agencias.voeazul.com.br/?_ga=2.70633875.2026753681.1499099044-1043486218.1497891289"
                target="_blank"
                rel="noopener noreferrer">
                {I18n.translate('components.header.agencies')}
              </a>
            </li>
            <li className="ta-item-menu">
              <a
                className="ta-item-link"
                href="http://www.azulcargo.com.br/"
                target="_blank"
                rel="noopener noreferrer">
                {I18n.translate('components.header.azulCargo')}
              </a>
            </li>
          </nav>
          <div className="ta-control-flag -anonymous">
            <div className="ta-flag-selected">
              <img className="ta-img-flag" src="styles/img/br-flag.png" alt="Português" />
              <span className="locale-selected">{I18n.translate('components.header.BRL')}</span>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="navbar-toggle collapsed"
          data-toggle="collapse"
          data-target="#navbar"
          aria-expanded="false"
          aria-controls="navbar">
          <span className="sr-only">{I18n.translate('components.header.toggleNavigation')}</span>
          <span className="icon-bar" />
          <span className="icon-bar" />
          <span className="icon-bar" />
          <span className="close" />
        </button>
        <div className="login-header">{this.renderLoggedUser()}</div>
      </div>
    );
  }

  renderMobile() {
    const { cookies } = this.props;
    return (
      <div
        id="navbar"
        className="navbar-collapse header-mobile collapse arrow_box"
        aria-expanded="false"
        style={{ height: 1 }}>
        <ul className="nav navbar-nav main_content">
          <li className="active">
            <a
              href="https://www.voeazul.com.br/br/pt/sua-viagem"
              target="_blank"
              rel="noopener noreferrer">
              {I18n.translate('components.header.forYourtrip')}
            </a>
          </li>
          <li className="ta-item-menu">
            <a
              href="https://www.voeazul.com.br/br/pt/sua-viagem/experiencia-azul"
              target="_blank"
              rel="noopener noreferrer">
              {I18n.translate('components.header.azulExperience')}
            </a>
          </li>
          <li className="ta-item-menu">
            <a
              href="https://www.voeazul.com.br/br/pt/imprensa/sobre-a-azul"
              target="_blank"
              rel="noopener noreferrer">
              {I18n.translate('components.header.meetAzul')}
            </a>
          </li>
        </ul>
        <ul className="nav navbar-nav second_content">
          <li className="ta-item-menu">
            <a
              className="ta-item-link"
              href="http://www.azulviagens.com.br/"
              target="_blank"
              rel="noopener noreferrer">
              {I18n.translate('components.header.azulTravel')}
            </a>
          </li>
          <li className="ta-item-menu">
            <a
              className="ta-item-link"
              href="http://agencias.voeazul.com.br/?_ga=2.70633875.2026753681.1499099044-1043486218.1497891289"
              target="_blank"
              rel="noopener noreferrer">
              {I18n.translate('components.header.agencies')}
            </a>
          </li>
          <li className="ta-item-menu">
            <a
              className="ta-item-link"
              href="http://www.azulcargo.com.br/"
              target="_blank"
              rel="noopener noreferrer">
              {I18n.translate('components.header.azulCargo')}
            </a>
          </li>
          <li id="mobileLogout">
            <Logout className="logoutMobile" display={this.state.isLogged} cookies={cookies} />
          </li>
        </ul>
      </div>
    );
  }

  renderLoggedUser() {
    const { cookies } = this.props;
    if (this.state.isLogged) {
      return (
        <span>
          <LoggedUser
            id="loggedUser"
            name={this.state.name}
            tudoAzulNumber={this.state.tudoAzulNumber}
            points={this.state.points}
          />
          <Logout display={this.state.isLogged} cookies={cookies} />
        </span>
      );
    }
  }

  render() {
    return (
      <header id="ta-header">
        {this.renderDesktop()}
        {this.renderMobile()}
      </header>
    );
  }
}

Header.propTypes = propTypes;

export default withCookies(Header);



// WEBPACK FOOTER //
// ./src/components/header/headerContainer/headerPortal/Header.jsx